export enum FunctionalityCode {
  ACUView = 'ACUView',
  ACDView = 'ACDView',
  ACEUView = 'ACEUView',
  ABEView = 'ABEView',
  AIView = 'AIView',
  BEView = 'BEView',
  CIView = 'CIView',
  AdminView = 'AdminView',
  GetRUADEResource = 'GetRUADEResource',
  GetACDUser = 'GetACDUser',
  GetUEOfMember = 'GetUEOfMember',
  GetACEUUserOfUE = 'GetACEUUserOfUE',
  GetAgencyOfUE = 'GetAgencyOfUE',
  GetIndustryOfUE = 'GetIndustryOfUE',
  GetABEUserOfUE = 'GetABEUserOfUE',
  GetAIUserOfUE = 'GetAIUserOfUE',
  GetBEUserOfUE = 'GetBEUserOfUE',
  GetCIUserOfUE = 'GetCIUserOfUE',
  GetResourceOfAgency = 'GetResourceOfAgency',
  GetResourceOfUE = 'GetResourceOfUE',
  GetProjectOfAgency = 'GetProjectOfAgency',
  GetOwnIndustry = 'GetOwnIndustry',
  GetAllUser = 'GetAllUser',
  GetAllMember = 'GetAllMember',
  GetAllOrganisation = 'GetAllOrganisation',
  GetProjectOfUE = 'GetProjectOfUE',
  ManageMember = 'ManageMember',
  ManageUE = 'ManageUE',
  ManageAgency = 'ManageAgency',
  GetRuadeCombustible = 'GetRuadeCombustible',
  SetRuadeResource = 'SetRuadeResource',
  ManageIndustry = 'ManageIndustry',
  CreateACD = 'CreateACD',
  CreateACEU = 'CreateACEU',
  CreateAI = 'CreateAI',
  CreateCI = 'CreateCI',
  CreateMO = 'CreateMO',
  CreateABE = 'CreateABE',
  CreateBE = 'CreateBE',
  CreateACU = 'CreateACU',
  CreateAdmin = 'CreateAdmin',
  ManageCombustible = 'ManageCombustible',
  SetUEResource = 'SetUEResource',
  SetAgencyResource = 'SetAgencyResource',
  SetProjectResource = 'SetProjectResource',
  ManageBlackIndustry = 'ManageBlackIndustry',
  ManageWhiteIndustry = 'ManageWhiteIndustry',
  ProjectView = 'ProjectView',
  IndustryView = 'IndustryView',
  ProductView = 'ProductView',
  DeviceView = 'DeviceView',
  TransportationView = 'TransportationView',
  TransportView = 'TransportView',
  ManageTransport = 'ManageTransport',
  CombustibleView = 'CombustibleView',
  UserView = 'UserView',
  AdministrationView = 'AdministrationView',
  StatisticView = 'StatisticView',
  MemberView = 'MemberView',
  UEView = 'UEView',
  AgencyView = 'AgencyView',
  EnergyView = 'EnergyView',
  LinkIndustryToUE = 'LinkIndustryToUE',
  PublishFormula = 'PublishFormula',
  DisableUser = 'DisableUser',
  StatisticUSIRFView = 'StatisticUSIRFView',
  StatisticACDView = 'StatisticACDView',
  StatisticUEView = 'StatisticUEView',
  VisitorPageView = 'VisitorPageView',
  OnlyIndustryView = 'OnlyIndustryView',
  CreateOnlyMobileCoatedIndustry = 'CreateOnlyMobileCoatedIndustry',
  ManageProducts = 'ManageProducts',
  ManageDevices = 'ManageDevices',
  ManageWorkshops = 'ManageWorkshops',
  ManageBlackProduct = 'ManageBlackProduct',
  ManageWhiteProduct = 'ManageWhiteProduct',
  ManageOtherProduct = 'ManageOtherProduct',
  ManageEnergie = 'ManageEnergie',
  ManageDredgingEnergie = 'ManageDredgingEnergie',
  ManageVehicleEnergie = 'ManageVehicleEnergie',
  ExportIndustries = 'ExportIndustries',
  ManageProductEcoPro = 'ManageProductEcoPro',
  ManageFamily = 'ManageFamily',
  ImportProject = 'ImportProject',
  WorkInspectionView = 'WorkInspectionView',
  ManageWorkInspection = 'ManageWorkInspection',
  ImportWorkInspection = 'ImportWorkInspection',
  CallForTenderView = 'CallForTenderView',
  RegionFilteringView = 'RegionFilteringView',
  HelpView = 'HelpView',
  UsefullDocsView = 'UsefullDocsView',
  TranslationView = 'TranslationView',
  ValidateCustomIndustry = 'ValidateCustomIndustry',
  ManageFdesCalcModel = 'ManageFdesCalcModel',
  CreateCustomIndustry = 'CreateCustomIndustry',
  PartnerApiProjects = 'PartnerApiProjects'
}
